<template>
  
  <b-sidebar
    v-model="modalOpen"
    v-if="modalOpen"
    centered
    id="branchModal"
    class="edit-modal"
    width="500px"
    backdrop
    no-close-on-backdrop
    no-close-on-esc
    no-header
    body-class="bg-white"
  >
    <div class="p-2">
      <validation-observer ref="moneyTransfer">
          <b-form @submit.prevent="onSubmit">
            <b-row>
              <b-col class="d-flex justify-content-between" cols="12">
                <h3> {{ mainTitle }} </h3>
                <feather-icon
                  size="20"
                  class="cursor-pointer"
                  @click="modalOpen = false"
                  icon="XIcon"
                />
              </b-col>
              <b-col cols="12">
                <hr />
              </b-col>
              <b-col cols="12">
                <form-select
                  label="رقم محضر الجلسة الإدارية التي تمّ خلالها الموافقة على التعديل"
                  v-model="form.meeting_minute_id"
                  :getOptionLabel="(x) => x.meeting_minutes_label"
                  :reduce="(x) => x"
                  id="gov"
                  ep="v2/selects/meeting-minutes"
                  ref="gov"
                  rules="required"
                />
                
                <small class="text-secondary mb-1 d-block" style="margin-top: -10px;">
                  في حال عدم وجود محضر الاجتماع يُرجى تقديم معاملة بالمحضر الجديد
                </small>
                
              </b-col>
              
              <b-col cols="12">
                <form-input
                  v-model="form.eligible_members_count"
                  rules="required|integer|min:1|max:20"
                  label="عدد الأعضاء الذين يحق لهم حضور اجتماع الهيئة العامة/ مجلس الأمناء"
                />
               
              </b-col>

              <b-col cols="12">
                <form-input
                  v-model="form.attended_member_count"
                  rules="required|integer|min:1|max:20"
                  label="عدد الأعضاء الحاضرين في الاجتماع"
                />
                <small v-if="isAttended" class="text-danger mb-1 d-block" style="margin-top: -10px;">
                  يجب أن يكون عدد الأعضاء الحاضرين أقل أو يساوي عدد الأعضاء الذي يحق لهم الحضور
                </small>
              </b-col>

              <b-col cols="12">
                <form-input
                  v-model="form.accepted_by_count"
                  rules="required|integer|min:1|max:20"
                  label="عدد الأعضاء الموافقين على التعديل"
                />
                
                <small v-if="isAccepted" class="text-danger mb-1 d-block" style="margin-top: -10px;">
                  يجب أن يكون عدد الأعضاء الموافقين على التعديل أقل أو يساوي عدد الأعضاء الحاضرين
                </small>
              </b-col>

              <b-col cols="12">
                <form-input
                  v-model="form.rejected_by_count"
                  rules="required|integer|min:1|max:20"
                  label="عدد الأعضاء الغير موافقين على التعديل"
                />
                
                <small v-if="isRejected" class="text-danger mb-1 d-block" style="margin-top: -10px;">
                  يجب أن يكون عدد الأعضاء الغير موافقين على التعديل أقل أو يساوي عدد الأعضاء الحاضرين
                </small>
              </b-col>
              <b-col cols="12">
                <small v-if="isTotal" class="text-danger mb-1 d-block" style="margin-top: -10px;">
                  يجب أن يكون عدد الأعضاء الموافقين و الغير موافين مُساوي لعدد الأعضاء الحاضرين
                </small>
              </b-col>

              <b-col cols="12">
                <h5 for=""> سيتم تعديل  </h5>
                <hr />
              </b-col>

              <b-col cols="12">
                <form-file-input
                  placeholder="اختر ملفاً"
                  id="document"
                  label="نسخة من النظام الداخلي الجديد"
                  accept=".doc,.pdf,.docx"
                  v-model="form.internal_system_doc"
                  :rules="internal ? 'required' : ''"
                />
              </b-col>

              <b-col cols="12">
                <form-input
                  v-model="form.modified_subject_numbers"
                  :rules="internal ? 'required' : ''"
                  label="ارقام المواد الجاري عليها التعديل"
                />
              </b-col>
              
              <b-col  cols="12">
                <b-form-checkbox class="my-1 mx-50" v-model="name"  @change="onChangeCheckbox($event ,'name')">
                    اسم المنظمة
                </b-form-checkbox>
              </b-col>

              <b-col cols="12" v-if="name">
                <form-input
                  v-model="form.name_ar"
                  :rules="name ? 'required' : ''"
                  label="اسم المنظمة باللغة العربية"
                />
              </b-col>

              <b-col cols="12" v-if="name">
                <form-input
                  v-model="form.name_en"
                  :rules="name ? 'required' : ''"
                  label="اسم المنظمة باللغة الإنكليزية"
                />
              </b-col>
              <b-col  cols="12">
                <b-form-checkbox class="my-1 mx-50" v-model="board_members_count"  @change="onChangeCheckbox($event ,'board_members_count')">
                    عدد أعضاء مجلس الإدارة / الإمناء
                </b-form-checkbox>
              </b-col>


              <b-col cols="12" v-if="board_members_count">
                <form-select
                  label="عدد أعضاء مجلس الإدارة / الإمناء" 
                  id="board_members_count"
                  :options="['1', '3', '5', '7', '9', '11']"
                  rules="required"
                  v-model="form.board_members_count"
                />
              </b-col>
              <b-col  cols="12">
                <b-form-checkbox class="my-1 mx-50" v-model="term_of_office"  @change="onChangeCheckbox($event ,'term_of_office')">
                    مدة ولاية مجلس الإدارة / الإمناء
                </b-form-checkbox>
              </b-col>

              <b-col cols="12" v-if="term_of_office">
                <form-input
                  v-model="form.term_of_office"
                  :rules="term_of_office ? 'required|integer|min:1|max:20' : ''"
                  label="مدة ولاية مجلس الإدارة / الإمناء(بالسنوات)"
                  placeholder="3"
                />
              </b-col>
              <b-col  cols="12">
                <b-form-checkbox class="my-1 mx-50" v-model="objectives"  @change="onChangeCheckbox($event ,'objectives')">
                    أهداف المنظمة
                </b-form-checkbox>
              </b-col>

              <b-col cols="12" v-if="objectives">
                <form-textarea
                  v-model="form.objectives"
                  rules="required"
                  :rules="objectives ? 'required' : ''"
                  label="أهداف المنظمة"
                />
              </b-col>

              <b-col  cols="12">
                <b-form-checkbox class="my-1 mx-50" v-model="governorate_id"  @change="onChangeCheckbox($event ,'governorate_id')">
                    نطاق عملها الجغرافي
                </b-form-checkbox>
              </b-col>

              <b-col cols="12" v-if="governorate_id">
                
                <small class="text-secondary mb-1 d-block" style="">
                  لن يمكنك التعديل على المحافظات التالية كونها مرتبطة بفروع
                  <br>
                  المقر الأم : {{ mainHqGovernorate }} /  فرع غير مشهر : {{ unKnownBranchGovernorate}} 
                </small>
                <form-select
                  placeholder="المحافظات"
                  v-model="form.governorate_id"
                  :getOptionLabel="(x) => x.name_ar"
                  :reduce="(x) => x"
                  id="governorate"
                  ep="v2/selects/geo-areas/1"
                  ref="governorate"
                  :rules="governorate_id ? 'required' :''"
                  multiple
                  :closeOnSelect="false"
                />
              </b-col>
            </b-row>
            <hr />

            <b-row class="px-1 justify-content-end">
              <b-button @click="modalOpen = false" class="mx-1">إلغاء</b-button>
              <save-btn
                type="submit"
                variant="success"
                :loading="loading"
                :label="btnLabel"
              >
              </save-btn>
            </b-row>
          </b-form>
        </validation-observer>
    </div>
    
  </b-sidebar>
</template>

<script>
import {
 BRow,
 BCol,
 BCard,
 BCardText,
 BCardTitle,
 BModal,
 BFormGroup,
 BFormFile,
 BFormRadio,
 BForm,
 BFormTextarea,
 BButton,
 BSidebar,
 BFormCheckbox
} from "bootstrap-vue";
import { ValidationObserver } from "vee-validate";
import formSelect from "@/components/form-select";
import formInput from "@/components/form-input";
import formTextarea from "@/components/form-textarea";
import saveBtn from "@/components/loader-btn";
import { required, integer } from "@validations";
import { ValidationProvider } from "vee-validate";
import FormFileInput from "@/components/FormFileInput.vue";
import FormCurrency from "@/components/FormCurrency.vue";
import FormMask from "@/components/form-mask";
import axios from "@axios";
const initForm = {};
export default {
 components: {
   formInput,
   formTextarea,
   formSelect,
   BButton,
   BSidebar,
   saveBtn,
   BRow,
   BCol,
   BCard,
   BCardText,
   BCardTitle,
   BModal,
   BFormGroup,
   BFormFile,
   BForm,
   BFormRadio,
   BFormTextarea,
   ValidationObserver,
   ValidationProvider,
   FormFileInput ,
   FormCurrency ,
   FormMask ,
   BFormCheckbox
 },
 props: {
   value: Boolean,
   title: String,
   mainTitle: {
     type: String,
     default: () => "بيانات المعاملة",
   },
   btnLabel: String,
   loading: Boolean,
   intializeForm: {
     type: Object,
     default: () => initForm,
   },
 },
 data() {
   return {
     form: {},
     objectives:false,
     governorate_id:false,
     term_of_office:false,
     board_members_count:false,
     isRejected : false ,
     isTotal : false,
     name:false,
     internal:true,
     isAccepted : false ,
     isAttended : false ,
     mainHqGovernorate : null,
     unKnownBranchGovernorate : null,
     required,
     integer,
   };
 },
 computed: {
   modalOpen: {
     set(val) {
       this.$emit("input", val);
     },
     get() {
       return this.value;
     },
   },
 },
 watch: {
   modalOpen(val) {
     if (val){
      // if(this.form.objectives)
      //   this.objectives=true;
      // if(this.form.governorate_id)
      //   this.governorate_id=true;
      // if(this.form.term_of_office)
      //   this.term_of_office=true;
      // if(this.form.board_members_count)
      //   this.board_members_count=true;
      // if(this.form.name_ar)
      //   this.name=true;
     }
      //  this.$nextTick(() => {
      //   //  this.init(this.intializeForm);
      //  });
   },
   form: {
      deep: true,
      handler(val) {
        console.log("form change" , this.form)
        if((parseInt(this.form.rejected_by_count)+parseInt(this.form.accepted_by_count))>= (parseInt(this.form.attended_member_count)+1)){
            this.isTotal = true
        }
        else{
          this.isTotal = false
        }
        if(parseInt(this.form.rejected_by_count)>parseInt(this.form.attended_member_count)){
           this.isRejected = true
        }
        else{
          this.isRejected = false
        }
        if(parseInt(this.form.accepted_by_count)>parseInt(this.form.attended_member_count)){
          this.isAccepted = true
        }
        else{
          this.isAccepted = false
        }
        if(parseInt(this.form.attended_member_count) > parseInt(this.form.eligible_members_count)){
          this.isAttended = true
        }
        else{
          this.isAttended = false
        }
      
      },
    

    },
   async governorate_id(val) {
     if (val)
      await axios.get('v2/selects/geo-areas/0')
      .then((res) => {
        this.mainHqGovernorate = res.data.data.mainHqGovernorate.map(item => item.name_ar).join(', ');
        this.unKnownBranchGovernorate = res.data.data.unKnownBranchGovernorate.map(item => item.name_ar).join(', ');
      })
      .catch((err) => {
        console.log(err)
      });
   },
 },

 methods: {
   init(form) {
     this.form = JSON.parse(JSON.stringify(form));
     if(this.form.objectives)
        this.objectives=true;
      if(this.form.governorate_id)
        this.governorate_id=true;
      if(this.form.term_of_office)
        this.term_of_office=true;
      if(this.form.board_members_count)
        this.board_members_count=true;
      if(this.form.name_ar)
        this.name=true;
   },
   async onSubmit() {
     await this.$refs.moneyTransfer.validate().then(async (success) => {
       if (success) {
        //  if(this.form.accepted_by_count>this.form.attended_member_count ||
        //  this.form.rejected_by_count>this.form.attended_member_count || 
        //  this.form.rejected_by_count+this.form.ccepted_by_count>this.form.attended_member_count){
        //   console.log("test")
        //  }else{
        if(this.isTotal == false && this.isRejected == false && this.isAccepted == false && this.isAttended == false ){

          this.$emit("confirm", this.form);
        }
        // }
       }
     });
   },
   onChangeCheckbox(value , key){
      console.log(this.form)
    console.log(value , key)
    if(!value){
      if(key == 'name'){
        delete this.form['name_ar']
        delete this.form['name_en']
      }
      else{
        delete this.form[key]
      }
      console.log(this.form)
    }
   }
 },
};
</script>
